import { render } from "./BlockedPeopleSection.vue.js?vue&type=template&id=c7725070!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./BlockedPeopleSection.vue?vue&type=template&id=c7725070"
import script from "./BlockedPeopleSection.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./BlockedPeopleSection.vue?vue&type=script&lang=js"
export * from "./BlockedPeopleSection.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./BlockedPeopleSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/SharedWeb/scripts/dynamic-component-editor/components/story-comments/BlockedPeopleSection.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c7725070"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c7725070', __exports__)) {
    api.reload('c7725070', __exports__)
  }
  
  module.hot.accept("./BlockedPeopleSection.vue.js?vue&type=template&id=c7725070!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./BlockedPeopleSection.vue?vue&type=template&id=c7725070", () => {
    api.rerender('c7725070', render)
  })

}


export default __exports__